import { useNavigate } from "react-router-dom";

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    rightContent?: React.ReactNode;
}

export function PageHeader({ title, subtitle, rightContent }: PageHeaderProps) {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
            <div className="flex items-center gap-4">
                <button
                    onClick={() => navigate("/")}
                    className="p-2 bg-slate-800 hover:bg-slate-700 rounded-xl border border-slate-700 transition-all group"
                    title="Back to Dashboard"
                >
                    <svg
                        className="w-5 h-5 text-slate-400 group-hover:text-white transition-colors"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                        />
                    </svg>
                </button>
                <div>
                    <h1 className="text-3xl font-extrabold text-white tracking-tight">{title}</h1>
                    {subtitle && <p className="text-slate-400">{subtitle}</p>}
                </div>
            </div>
            {rightContent && <div>{rightContent}</div>}
        </div>
    );
}
